import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = 'usuarios/usuarios-limitaciones-de-informacion';

/**
 * GET Usuarios Permisos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getUsuariosPermisos = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  // eslint-disable-next-line no-unreachable
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Usuario Permiso
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getUsuarioPermiso = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Tipo de Plaza
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUsuariosPermisos = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Usuarios Permisos
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchUsuariosPermisos = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Usuarios Permisos
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteUsuariosPermisos = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
